import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
// import { AppData } from './app-data.service';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {
  _AppData: any;
  publicKey = ''

  constructor() { }

  private CryptoJSAesJson = {
    stringify: function (cipherParams) {
      const vbJsonString = {
        hv: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)
      };
      if (cipherParams.iv) {
        vbJsonString['iv'] = cipherParams.iv.toString()
      };
      if (cipherParams.salt) {
        vbJsonString['s'] = cipherParams.salt.toString()
      };
      return JSON.stringify(vbJsonString);
    },
    parse: function (jsonStr) {
      const vbJsonParse = JSON.parse(jsonStr);
      const cipherParams = CryptoJS.lib.CipherParams.create({
        ciphertext: CryptoJS.enc.Base64.parse(vbJsonParse.hv)
      });
      if (vbJsonParse.iv) {
        cipherParams['iv'] = CryptoJS.enc.Hex.parse(vbJsonParse.iv)
      }
      if (vbJsonParse['s']) {
        cipherParams.salt = CryptoJS.enc.Hex.parse(vbJsonParse.s)
      }
      return cipherParams;
    }
  }

  Encrypt = (data: any) => {
    let userToken: any;
    const userData = this._AppData.getUserDetails();
    if (userData) {
      userToken = userData.remembertoken;
    }
    return CryptoJS.AES.encrypt(JSON.stringify(data), userToken ? userToken.slice(-10) : 'waAgexGyN', { format: this.CryptoJSAesJson }).toString();
  }

  Decrypt = (data: any, useStaticToken: boolean = false) => {
    // console.log(data)
    let userToken: any;
    const userData = this._AppData.getUserDetails();
    console.log("userData", userData)
    if (userData) {
      userToken = userData?.remembertoken?.slice(-10);
    }
    if (useStaticToken) {
      userToken = 'waAgexGyN';
    }
    if (!userToken) {
      userToken = 'waAgexGyN';
    }

    console.log("Using ", userToken);

    // console.log(JSON.parse(CryptoJS.AES.decrypt(JSON.stringify(data), userToken, { format: this.CryptoJSAesJson }).toString(CryptoJS.enc.Utf8)));
    // if(this.userToken){
    return JSON.parse(CryptoJS.AES.decrypt(JSON.stringify(data), userToken, { format: this.CryptoJSAesJson }).toString(CryptoJS.enc.Utf8));
    // }
  }
}
